import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../Footer";
import { Link } from "react-router-dom";
import axios from "axios";
import { toTitleCase } from "../helper/formatCarName";
import { SkeletonCard } from "../components/SkeletonLoader";
import CarCard from "../components/CarCard";

const PendingUnlocks = () => {
  const [pendingList, setPendingList] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);

  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };
  const storedUserPreferences = getDataFromlocalStorage("userData");

  const fetchData = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/get/bidder/bids",
        {
          bidder_id: storedUserPreferences?.id,
        }
      );
      const filteredData = response?.data.biddings.filter(
        (item) => item.status === "pending"
      );

      setPendingList(filteredData);
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    } finally {
      setPageLoading(false);
    }
  };
  function formatEuroAmount(amount) {
    const parts = amount.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  useEffect(() => {
    fetchData();
  }, []);
  function backto() {
    window.history.back();
  }
  return (
    <>
      <Navbar />
      <div className="cl-page">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
            <div>
              <h3 className="cl-page-title">Pending Unlocks</h3>
              <p className="cl-page-subtitle">Requests waiting for approval</p>
            </div>
            <button onClick={backto} type="button" className="cl-btn cl-btn-outline cl-btn-sm">
              <i className="fa fa-arrow-left"></i>Back
            </button>
          </div>
          {pageLoading ? (
            <SkeletonCard count={8} />
          ) : (
          <div className="row g-3">
            {pendingList?.length === 0 ? (
              <div className="col-12">
                <div className="cl-empty">
                  <div className="cl-empty-icon"><i className="fa-solid fa-clock"></i></div>
                  <h6 className="cl-empty-title">No Pending Requests</h6>
                  <p className="cl-empty-text">You don't have any requests waiting for approval right now.</p>
                </div>
              </div>
            ) : (
              pendingList?.map((car) => (
                <div
                  key={car?.id}
                  className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6"
                >
                  <CarCard
                    carData={car?.car}
                    extraBodyContent={
                      <div className="mt-1 pt-1" style={{ borderTop: "1px solid #e5e7eb" }}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span style={{ fontSize: "11px", color: "#6b7280" }}>Offer</span>
                          <span className="fw-bold text-truncate text-end" style={{ fontSize: "12px", color: "#00889c", maxWidth: "60%" }}>£{formatEuroAmount(car.amount)}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span style={{ fontSize: "11px", color: "#6b7280" }}>Request</span>
                          <span className="fw-semibold text-capitalize text-truncate text-end" style={{ fontSize: "10px", color: "#00889c", maxWidth: "60%" }}>{car.bid_request}</span>
                        </div>
                        <div className="d-flex justify-content-center mt-1">
                          <span className="badge" style={{ backgroundColor: "#ffc107", color: "#111827", fontSize: "10px", padding: "4px 10px", borderRadius: "4px" }}>
                            <i className="fa-solid fa-clock me-1"></i>Pending
                          </span>
                        </div>
                      </div>
                    }
                    hideFooter={true}
                  />
                </div>
              ))
            )}
          </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PendingUnlocks;
